// Configuraciones de tours para diferentes páginas
export const tourConfigs = {
  "account-setup": {
    title: "Configuración del Perfil",
    steps: [
      {
        element: "[data-tour='logo-empresa']",
        popover: {
          title: "Logo de Empresa",
          description: "Sube el logo de tu empresa para personalizar tu perfil.",
          side: "bottom",
          align: "start",
        },
      },
      {
        element: "[data-tour='habilitar-qr']",
        popover: {
          title: "Habilitar QR para Pagos",
          description: "Activa esta opción si quieres enviar un QR para pagos a tus clientes.",
          side: "bottom",
          align: "start",
        },
      },
      {
        element: "[data-tour='qr-pagos']",
        popover: {
          title: "QR de Pagos",
          description: "Sube la imagen del QR que usarás para recibir pagos.",
          side: "bottom",
          align: "start",
        },
      },
      {
        element: "[data-tour='mensaje-qr']",
        popover: {
          title: "Mensaje adjunto al QR",
          description: "Agrega un mensaje personalizado que se enviará junto al QR de pago.",
          side: "bottom",
          align: "start",
        },
      },
      {
        element: "[data-tour='estado-envio']",
        popover: {
          title: "Estado para el envío",
          description: "Selecciona en qué estado de la reserva se enviará el QR de pago.",
          side: "bottom",
          align: "start",
        },
      },
      {
        element: "[data-tour='datos-generales']",
        popover: {
          title: "Datos Generales del Negocio",
          description:
            'Completa los datos principales de tu empresa y revisa la URL de tu página de reservas.<br><img src="/onboarding/My-profile.png" alt="Ejemplo de datos generales" style="max-width:320px;width:100%;height:auto;margin-top:10px;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">',
          side: "top",
          align: "center",
        },
      },
    ],
  },
  "business-hours": {
    title: "Horarios de Atención",
    steps: [
      {
        element: "[data-tour='add-horario']",
        popover: {
          title: "Agregar Horario",
          description: "Haz clic aquí para agregar un nuevo horario de atención.",
          side: "bottom",
          align: "center",
        },
      },
      {
        element: "[data-tour='horario-atencion']",
        popover: {
          title: "Configura tus Horarios",
          description: "Completa los días y horas en los que estarás disponible para tus clientes.",
          side: "top",
          align: "center",
        },
      },
    ],
  },

  "first-service": {
    title: "Crear Primer Servicio",
    steps: [
      // Paso 0: Crear con IA
      {
        element: "[data-tour='crear-con-ia']",
        popover: {
          title: "Crear Servicio con IA",
          description: "Haz clic aquí para crear tu primer servicio usando inteligencia artificial.",
          side: "bottom",
          align: "center",
        },
      },
      // Paso 1: Crear servicio manual
      {
        element: "[data-tour='crear-servicio-listado']",
        popover: {
          title: "Crear Servicio Manual",
          description: "Haz clic aquí para crear tu primer servicio de forma manual.",
          side: "bottom",
          align: "center",
        },
      },
      // Bloque 1: Datos principales
      {
        element: "[data-tour='form-bloque1']",
        popover: {
          title: "Datos Principales del Servicio",
          description:
            'Completa el nombre, imagen, descripción y precio del servicio. <br><img src="/onboarding/service1.png" alt="Ejemplo de datos generales" style="max-width:180px;width:100%;height:auto;margin-top:10px;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">',
          side: "right",
          align: "start",
        },
      },
      // Bloque 2: Configuración y opciones
      {
        element: "[data-tour='form-bloque2']",
        popover: {
          title: "Configuración y Opciones",
          description:
            'Configura las opciones de pago, reserva anticipada y comisión de empleado. <br><img src="/onboarding/service2.png" alt="Ejemplo de datos generales" style="max-width:180px;width:100%;height:auto;margin-top:10px;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">',
          side: "right",
          align: "start",
        },
      },
      // Bloque 3: Categoría, duración y extras
      {
        element: "[data-tour='form-bloque3']",
        popover: {
          title: "Categoría, Duración y Extras",
          description:
            'Selecciona la categoría, duración estimada, método y opciones avanzadas del servicio. <br><img src="/onboarding/service3.png" alt="Ejemplo de datos generales" style="max-width:180px;width:100%;height:auto;margin-top:10px;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">',
          side: "right",
          align: "start",
        },
      },
      // Paso final: Guardar servicio
      {
        element: "[data-tour='guardar-servicio']",
        popover: {
          title: "Guardar Servicio",
          description: "Haz clic aquí para guardar tu primer servicio y empezar a recibir reservas.",
          side: "top",
          align: "center",
        },
      },
    ],
  },

  "branch-setup": {
    title: "Configura tu Sucursal",
    steps: [
      {
        element: "[data-tour='sucursal-nombre']",
        popover: {
          title: "Nombre de la Sucursal",
          description: "Ingresa el nombre de tu sucursal.",
          side: "top",
          align: "center",
        },
      },
      {
        element: "[data-tour='sucursal-mapa']",
        popover: {
          title: "Ubicación",
          description: "Selecciona la ubicación de tu sucursal en el mapa.",
          side: "top",
          align: "center",
        },
      },
      {
        element: "[data-tour='sucursal-bloque']",
        popover: {
          title: "Datos de dirección y servicios",
          description:
            'Completa la dirección, teléfono y servicios de la sucursal. <br><img src="/onboarding/bloque-branch.png" alt="Ejemplo de datos generales" style="max-width:320px;width:100%;height:auto;margin-top:10px;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">',
          side: "top",
          align: "center",
        },
      },
    ],
  },

  "employee-setup": {
    title: "Crea tus Empleados",
    steps: [
      {
        element: "[data-tour='employee-photo']",
        popover: {
          title: "Foto de Empleado",
          description: "Agrega una foto para tu empleado.",
          side: "top",
          align: "center",
        },
      },
      {
        element: "[data-tour='employee-general-data']",
        popover: {
          title: "Datos Generales",
          description:
            'Completa los datos personales del empleado. <br><img src="/onboarding/employee-general.png" alt="Ejemplo de datos generales" style="max-width:320px;width:100%;height:auto;margin-top:10px;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">',
          side: "top",
          align: "center",
        },
      },
      {
        element: "[data-tour='employee-service-method']",
        popover: {
          title: "Método de Servicio y Sucursal",
          description:
            'Selecciona el método de servicio y la sucursal del empleado. <br><img src="/onboarding/metodos.png" alt="Ejemplo de método de servicio" style="max-width:320px;width:100%;height:auto;margin-top:10px;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">',
          side: "top",
          align: "center",
        },
      },
      {
        element: "[data-tour='employee-commissions']",
        popover: {
          title: "Comisiones y Disponibilidad",
          description:
            'Configura las comisiones y la disponibilidad del empleado. <br><img src="/onboarding/disponibilidad.png" alt="Ejemplo de método de servicio" style="max-width:220px;width:100%;height:auto;margin-top:10px;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">',
          side: "top",
          align: "center",
        },
      },
    ],
  },
};

// Función para obtener la configuración de un tour específico
export const getTourConfig = (tourId) => {
  return tourConfigs[tourId] || null;
};

// Función para obtener todos los IDs de tours disponibles
export const getAvailableTours = () => {
  return Object.keys(tourConfigs);
};
